












































import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import GlobalMixin from "@/mixins/global";

export default GlobalMixin.extend({
  props: {
    dialogRefuse: { type: Boolean, default: false },
    registroSTPSEdit: { type: Object, default: {} },
    keyFile: { type: String, default: "" },
  },
  data: () => ({
    motiveRefuse: "",
    valid: false,

    specialCharacter(propertyType: any) {
      return (v: string) =>
        /^[\w&.\-/ ]+$/.test(v) ||
        `Campo ${propertyType} no debe contener caracteres especiales`;
    },
    return: {
      moduleName: "DIALOG_REFUSE",
    },
  }),
  methods: {
    closeRefuse() {
      this.motiveRefuse = "";
      this.$emit("closeRefuse");
    },
    refuseItemConfirm() {
      dataService
        .refuseRegisterSTPS(
          this.registroSTPSEdit.registroSTPSID,
          this.motiveRefuse
        )
        .then((Response: ResponseData) => {
          this.registroSTPSEdit.registroSTPSEstatusID = 3;
          this.registroSTPSEdit.registroSTPSBucketKeyFile = this.keyFile;
          this.$emit("saveItemRefuse");
          this.$emit(
            "notificacion",
            "Registro rechazado correctamente",
            "success"
          );
          this.$emit("refuseItemConfirm");
        })
        .catch((e: Error) => {
          this.$emit(
            "notificacion",
            "No se pudo rechazar el registro, intente de nuevo más tarde" + e,
            "red darken-2"
          );
        })
        .finally(() => {
          this.motiveRefuse = "";
        });
    },
  },
});
